import { useQuery } from '@tanstack/react-query'

import { useAppSelector } from 'common/hooks/redux'
import { useContent } from 'features/unifiedFlow/contentPage/hooks'

import { getCampaigns } from '../api'
import { importKeys } from '../queryKeys'

const useGetCampaignsQuery = ({ integration }: { integration: string }) => {
  const accountId = useAppSelector((state) => state.authStates.accountId)
  const { content } = useContent()

  const projectId =
    content?.elements[0]?.optimization_settings?.configuration?.project_id ?? ''

  return useQuery(
    importKeys.campaigns({ accountId, projectId, integration }),
    () => getCampaigns({ accountId, projectId, integration }),
    {
      enabled: !!projectId,
      select: (data) => (Array.isArray(data) ? data : []),
    }
  )
}

export default useGetCampaignsQuery
